import { $http } from '@/utils/https';
import { objectToQueryString } from '@/helpers/variables';

interface State {}

const state: State = {};

const getters = {};

const actions = {
  // eslint-disable-next-line no-unused-vars
  GET_OUTLET_PRODUCTS: async ({ commit }: any, params: any) => {
    let url = `v1/selection/get_products`;
    if (params && Object.keys(params).length) {
      let categories = `799`;
      if (params.categories) {
        categories = `${categories},${params.categories}`;
      }

      //---NOTE: rewrite per_page in init load products
      url = objectToQueryString(url, { per_page: 12, ...params, categories });
    }

    try {
      const response = await $http.get(url);
      return response.data;
    } catch (e) {
      throw e;
    }
  }
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
